import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import { FiChevronUp } from "react-icons/fi";
import ScrollToTop from 'react-scroll-up';
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";



/* const ServiceList = [
    {
        icon:<img alt="" src={Icon3} /> ,
        title: 'Advertising',
        description: 'I throw myself down among the tall grass by the stream as I lie close to the earth.'
    },
    {
        icon: <img alt="" src={Icon2} />,
        title: 'Development',
        description: 'I throw myself down among the tall grass by the stream as I lie close to the earth.'
    },
    {
        icon: <img alt="" src={Icon1} />,
        title: 'Design',
        description: 'I throw myself down among the tall grass by the stream as I lie close to the earth.'
    },
    {
        icon: <img alt="" src={Icon5} />,
        title: 'Marketing',
        description: 'I throw myself down among the tall grass by the stream as I lie close to the earth.'
    },
    {
        icon: <img alt="" src={Icon4} />,
        title: 'Printing',
        description: 'I throw myself down among the tall grass by the stream as I lie close to the earth.'
    },
    {
        icon: <img alt="" src={Icon6} />,
        title: 'Branding',
        description: 'I throw myself down among the tall grass by the stream as I lie close to the earth.'
    },
] */

class Service extends Component{
    render(){
        
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Services' />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <Breadcrumb title={'Services'}   />
                {/* End Breadcrump Area */}

                {/* Start Service Area */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content pb--80 align-items-center">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/service/AdvertisingCover.jpg" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                <h4 className="title">Advertising</h4>
                                                    <p>Mercury Branding is a full-service advertising agency that specializes in creating and executing campaigns for brands of all sizes. We have a team of experienced professionals who are experts in all things advertising, from strategy and planning to media buying and creative execution. We're passionate about helping our clients reach their marketing goals, and we're always looking for new and innovative ways to get the job done.</p>
                                                    <p>If you're looking for an advertising agency that can help you take your brand to the next level, Mercury is the perfect partner. We'll work with you to create a customized campaign that targets your specific audience and achieves your desired results. Contact us today to learn more about what we can do for you.</p>

                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="view-more-btn mt--60 text-center">
                                                        <a className="rn-button-style--2 btn-solid" href="/contact"><span>Contact us now</span></a>
                                                    </div>
                                                 </div>
                                            </div>
                                            
                                        </div>
                                        {/* End Single Area */}

                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-6 col-12 order-2 order-lg-1">
                                                <div className="details mt_md--30 mt_sm--30">
                                                <h4 className="title">Coding</h4>
                                                    <p>If you're running a business, you know that image is important. Your website is one of the first places potential customers will go to learn about your company, and first impressions matter. That's where a Mercury Branding can come in handy. Mercury Branding can help you design and develop a website that not only looks professional, but also functions well.</p>
                                                    <p>Looking for a top-notch coding agency, look no further than Mercury Branding. We have a team of experienced coders who can take your project from concept to completion. We're also proud to offer competitive pricing and quick turnaround times. Contact us today to learn more about what we can do for you!</p>
                                        
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="view-more-btn mt--60 text-center">
                                                        <a className="rn-button-style--2 btn-solid" href="/contact"><span>Contact us now</span></a>
                                                    </div>
                                                 </div>
                                            </div>
                                            <div className="col-lg-6 col-12 order-1 order-lg-2">
                                                <div className="thumb position-relative">
                                                    <img className="w-100" src="/assets/images/service/CodingCover.jpg" alt="Service Images"/>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                        <br /> <br /><br /> 
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content pb--80 align-items-center">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/service/DesignCover.jpg" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                     <h4 className="title">Design</h4>
                                                    <p>If you're looking for a design agency that can help you create a powerful and effective brand, then look no further than Mercury Branding. We specialize in helping businesses of all sizes develop a strong identity that will resonate with their target audiences. We'll work with you to understand your unique needs and objectives, and then we'll create a custom branding strategy that will help you achieve your goals. We offer a wide range of services, including logo design, brand development, and marketing collateral creation. So whether you're just starting out or you're ready to take your brand to the next level, we can help. Contact us today to learn more about what we can do for you.</p>
                                                    <div className="col-lg-12">
                                                    <div className="view-more-btn mt--60 text-center">
                                                        <a className="rn-button-style--2 btn-solid" href="/contact"><span>Contact us now</span></a>
                                                    </div>
                                                 </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-6 col-12 order-2 order-lg-1">
                                                <div className="details mt_md--30 mt_sm--30">
                                                <h4 className="title"> Marketing</h4>
                                                    <p>If you're looking for a marketing agency that can help take your business to the next level, look no further than Mercury Branding. We specialize in helping businesses create and execute marketing campaigns that get results. Whether you're looking to reach a new audience or grow your existing customer base, we can help. We offer a full suite of marketing services, from brand strategy and identity development to digital marketing and public relations. We also offer web design and development services. In other words, we can help with every aspect of your marketing, from start to finish.</p>
                                                    <p>What sets us apart from other agencies is our commitment to results. We don't just want to create pretty campaigns; we want to create campaigns that deliver results. That's why we work closely with our clients to understand their business goals and develop strategies that will help them achieve those goals.</p>                                               
                                                    <p>If you're ready to take your marketing to the next level, contact us today. </p>
                                                    <div className="col-lg-12">
                                                    <div className="view-more-btn mt--60 text-center">
                                                        <a className="rn-button-style--2 btn-solid" href="/contact"><span>Contact us now</span></a>
                                                    </div>
                                                 </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 order-1 order-lg-2">
                                                <div className="thumb position-relative">
                                                    <img className="w-100" src="/assets/images/service/MarketingCover.jpg" alt="Service Images"/>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                        <br /> <br /><br /> <br /><br /> 
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content pb--80 align-items-center">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/service/PrintingCover.jpg" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                <h4 className="title">Printing</h4>
                                                    <p>Mercury Branding is a printing agency that specializes in creating high-quality prints for businesses of all sizes. We understand the importance of branding and how it can impact your business. That’s why we offer a wide range of printing services that are designed to help you promote your brand in the most effective way possible.</p>
                                                    <p>From business cards and brochures to signage and promotional materials, we can print anything you need to help get your brand out there. We also offer a wide range of customization options so you can create prints that are truly unique to your brand.</p>
                                                    <p>Contact us today to learn more about our services and how we can help you promote your business.</p>                                                    
                                                    <div className="col-lg-12">
                                                    <div className="view-more-btn mt--60 text-center">
                                                        <a className="rn-button-style--2 btn-solid" href="/contact"><span>Contact us now</span></a>
                                                    </div>
                                                 </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-6 col-12 order-2 order-lg-1">
                                                <div className="details mt_md--30 mt_sm--30">
                                                <h4 className="title">Branding</h4>
                                                    <p>If you're like most people, the word "branding" probably conjures up images of big companies with huge budgets and teams of marketing experts. But the truth is, branding is something that any business, no matter its size or budget, can benefit from. And it doesn't have to be complicated or expensive.</p>
                                                    <p>As a branding agency, Mercury Branding strives to create unique and memorable brands for our clients. We understand that a strong brand can be the difference between success and failure in today’s competitive marketplace. That’s why we take the time to get to know our clients and their businesses before we begin the branding process. Once we have a clear understanding of our client’s goals, values, and target audience, we can begin developing a brand that will resonate with your customers. We believe that every brand has a story to tell, and we strive to tell that story in a way that is both creative and memorable.</p>
                                                    <p>Contact us today. We’d be happy to discuss your branding goals and how we can help you achieve them.</p>
                                                    <div className="col-lg-12">
                                                    <div className="view-more-btn mt--60 text-center">
                                                        <a className="rn-button-style--2 btn-solid" href="/contact"><span>Contact us now</span></a>
                                                    </div>
                                                 </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 order-1 order-lg-2">
                                                <div className="thumb position-relative">
                                                    <img className="w-100" src="/assets/images/service/BrandingCover.jpg" alt="Service Images"/>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Service Area */}

                {/* Start Service Area */}
               {/*  <div className="service-area ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--30">
                                    <h2>Strategy</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, <br /> but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row service-one-wrapper">
                            {ServiceList.map( (val , i) => (
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                                    <a className="text-center" href="/service-details">
                                        <div className="service service__style--2">
                                            <div className="icon">
                                                {val.icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{val.title}</h3>
                                                <p>{val.description}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div> */}
                {/* End Service Area */}

                {/* Start Service Area */}
               {/*  <div className="service-area creative-service-wrapper pt--90 pb--120 bg_color--5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--30">
                                    <h2>Creative Agency</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, <br /> but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row creative-service">
                            {ServiceList.map( (val , i) => (
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                                    <a href="/service-details">
                                        <div className="service service__style--2">
                                            <div className="icon">
                                                {val.icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{val.title}</h3>
                                                <p>{val.description}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div> */}
                {/* End Service Area */}

                {/* Start Service Area */}
              {/*   <div className="service-area creative-service-wrapper pt--90 pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--30">
                                    <h2>Development</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, <br /> but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row creative-service">
                            {ServiceList.map( (val , i) => (
                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                                    <a className="text-center" href="/service-details">
                                        <div className="service service__style--2">
                                            <div className="icon">
                                                {val.icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{val.title}</h3>
                                                <p>{val.description}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div> */}
                {/* End Service Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />


            </React.Fragment>
        )
    }
}
export default Service;